import { createContext } from 'react';
import IWidgetConfiguration from '../../../../common/model/IWidgetConfiguration';
import EventContainer from '../../../../common/event/EventContainer';

const WidgetContext = createContext<[IWidgetConfiguration, EventContainer] | null>(null);

export default WidgetContext;
